const stateManager = require('../state/stateManager');

const navigationPageAction = require('../state/actions/views/navigationPage/navigationPageAction');
const screenKeyboardAction = require('../state/actions/views/onScreenKeyboard/screenKeyboardAction');

module.exports.dispatchNavigationPageAction = function (payload)
{
    stateManager.getStore().dispatch(navigationPageAction.createAction(payload));
}

module.exports.dispatchScreenKeyboardAction = function (payload)
{
    stateManager.getStore().dispatch(screenKeyboardAction.createAction(payload));
}
